import React, { useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./css/NoteTable.css";
import { useForm, Controller } from "react-hook-form";
import { useRBAC } from "../../hooks/RBACContext";

const NoteTable = ({
  data,
  columns,
  mode,
  newNotes,
  maxLength=50,
  handleChangeNewNote,
  handleSaveNotes,
}) => {
  const { writeAccess } = useRBAC();
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      notes: newNotes,
    },
  });

  const inputRefs = useRef([]);
  const prevRowCount = useRef(newNotes.length);

  const onSubmit = (formData) => {
    handleSaveNotes(formData.notes);
    reset({ notes: [] });
  };

  const formRef = useRef(null);
  const firstInputRef = useRef(null);

  const handleKeyUpRef = useRef();

  useEffect(() => {
    if(writeAccess){
          handleKeyUpRef.current = (event) => {
      const { key } = event;
      // const button = ctaButtons.find((b) => b.button_key === key);
      if (key === "Enter") {
        event.preventDefault();
        handleSubmit(onSubmit);
      }
    };

    const handleKeyPress = (event) => handleKeyUpRef.current(event);
    window.addEventListener("keyup", handleKeyPress);

    return () => {
      window.removeEventListener("keyup", handleKeyPress);
    };
    }

  }, [handleSubmit, onSubmit]);

  useEffect(() => {
    if(writeAccess){
       if (mode === "add" && firstInputRef.current) {
      firstInputRef.current.focus();
    }

    if (newNotes.length > prevRowCount.current) {
      const emptyNoteIndex = newNotes.slice(prevRowCount.current).findIndex(
        (note) => note === ""
      );
  
      if (emptyNoteIndex !== -1) {
        const absoluteIndex = prevRowCount.current + emptyNoteIndex;
        inputRefs.current[absoluteIndex]?.focus();
      }
    }
    prevRowCount.current = newNotes.length;
    }
   
  }, [newNotes,mode]);

  const handleInputChange = (rowIndex, value) => {
    handleChangeNewNote(rowIndex, value);

    if (value.length === maxLength && rowIndex < newNotes.length - 1) {
      const nextInput = inputRefs.current[rowIndex + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const mappedData = data.map((item) => {
    let mappedItem = {};
    columns.forEach((col) => {
      if (item.hasOwnProperty(col.key)) {
        mappedItem[col.key] = item[col.key];
      }
    });
    return mappedItem;
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="table-container">
        {mode === "add" && (
          <Button
            label="Save"
            type="submit"
            severity="primary"
/*onClick={handleSubmit(onSubmit)}*/
            className="note-submit"
          />
        )}
        <DataTable
          value={
            mode === "view" ? mappedData : newNotes.map((note) => ({ note }))
          }
          paginator={false}
          emptyMessage="No available options"
          showGridlines
        >
          {columns.map((col, index) => (
            <Column
              key={index}
              field={col.key}
              header={col.header}
              body={(rowData, { rowIndex }) => {
                if (mode === "add") {
                  return (
                    <Controller
                      name={`notes[${rowIndex}]`}
                      control={control}
                      render={({ field }) => (
                        <InputText
                          {...field}
                          value={field.value || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleInputChange(rowIndex, value);
                          }}
                          className="note-input"
                          ref={(el) => (inputRefs.current[rowIndex] = el)}
                          maxLength={maxLength}
                          autoComplete="off"
                          aria-autocomplete="none"
                        />
                      )}
                    />
                  );
                }
                return rowData[col.key];
              }}
              style={{
                width: index === 0 ? "80%" : "10%",
                padding: mode === "view" ? "10px 1vw" : "10px 2px",
              }} // Adjust the width for the columns
            />
          ))}
        </DataTable>
      </div>
    </form>
  );
};

export default NoteTable;